<template>
  <b-modal ref="modal" hide-footer title="Add Document" size="lg" id="companyAddDocumentModal">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
    <b-row class="my-1">
      <b-col md="3">
        <label for="notes">Select Document</label>
      </b-col>
      <b-col md="9">
        <validation-provider
            name="File"
            :rules="{ required: true }"
            v-slot="validationContext"
          >
          <b-form-file
            v-model="file1"
            :state="getValidationState(validationContext)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
                       multiple
          ></b-form-file>
         </validation-provider>
      </b-col>
    </b-row>



    <b-row class="my-1">
      <b-col md="3">
      </b-col>
      <b-col md="9">
        <b-button type="submit" variant="success" class="margin-right" >
          <font-awesome-icon icon="save" /> Save
        </b-button>
        <b-button type="reset" variant="danger" @click="hideModal">
          <font-awesome-icon icon="times" /> Cancel
        </b-button>
      </b-col>
    </b-row>

    <b-row class="my-1" v-if="errorMessage != null">
      <b-col md="3">
      </b-col>
      <b-col md="9">
        <b-alert variant="danger" show>{{errorMessage}}</b-alert>
      </b-col>
    </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
//import store from '@/helpers/Store'
export default {
  props: [ 'companyId' ],
  data() {
    return {
      file1: null,
      errorMessage: null
    };
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.errorMessage = null;
      this.$refs["modal"].hide();
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {

      let formData = new FormData();
      this.file1.map(function (file, key) {
        formData.append('files[' + key + ']', file);
      })
      
      formData.append('companyId', this.$props.companyId);
      /*
      formData.append('companyDocumentCategoryId', null);
      formData.append('documentName', null);
      formData.append('receivedDate', null);
      formData.append('ndaSourceId', null);
      */
      this.$http.post('companydocument', formData).then(() => {
        this.hideModal();
      }).catch(error => {
        if (error.status == 415) {
          this.errorMessage = 'Invalid file type.';
        }
        else if (error.status == 413) {
          this.errorMessage = 'File too large.';
        }
        else {
          this.errorMessage = 'An unknown error occurred, please try again.';
        }
      });

    },
  },
};
</script>

<style scoped>
</style>
